<!-- 组件说明 -->
<template>
  <div>
    <van-nav-bar
      title="産品列表"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      />
     <van-row type="flex" gutter="10" style="flex-wrap: wrap; margin:0 0.24rem">
      <van-col span="12" v-for="(item,index) in goods" :key="index">
        <div class="item_padding">
          <div :class="['goods_item']" @click="goDetail(item.prodId)">
            <van-image :src="item.pic" class="goods_img" />
            <div class="content">
              <div class="goods_name">{{item.prodName}}</div>
              <div class="goods_menu">
                <div class="price">
                  <span>{{$t('Pay.money')}}{{item.price}}</span>
                </div>
                <!-- <div class="add_cart" @click="addCart(item)">
                  <van-icon name="cart-o" />
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </van-col>
      <div class="buy_btn_l" @click="toCart()">
        <van-goods-action-icon icon="cart-o" :info="count ==0?'':count" />
      </div>
    </van-row>
  </div>
 
</template>

<script>
import { Toast, Image ,NavBar } from 'vant';
import goods from '@/api/goods';
import { mapMutations, mapState } from 'vuex';
import { moneys } from "../../static/moneyString"
export default {
  components: {},
  data() {
    return {
      moneysString:'',
      goods: [],
    };
  },
  computed: {
    count: {
      get() {
        let cartGoods = this.$store.state.goods.shopCardGoods;
        let count = cartGoods.reduce((total, item) => total + item.num, 0);
        return count;
      },
    },
  },
  created() {
    // console.log('====created=======', window);
  },
  mounted() {
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
    goods.list(this.$store.state.designer.shopId).then((res) => {
      // console.log('====res=======', res);
      this.goods = res.records;
    });
    goods.pageProd({categoryId:this.$store.state.designer.shopId}).then((res) => {
      // console.log('====res=======', res);
      this.goods = res.records;
    });
    
  },
  methods: {
    ...mapMutations('goods', {
      addShopCardGoods: 'addShopCardGoods',
    }),
    addCart(item) {
      event.stopPropagation(); //原生阻止冒泡事件

      this.addShopCardGoods(item);
      Toast('添加成功');
    },
    goDetail(id) {
      this.$router.push({ name: 'GoodsDetail', params: { prodId: id} });
    },
    toCart(){
       this.$router.push({ name: 'Cart'});
    },
    onClickLeft() {   //返回上一页
      this.$router.go(-1);
    },
  },
};
</script>

<style lang='scss' scoped>
.title{
  width: 100%;
  height: 1.5rem;
  background: #b13240;
  text-align: center;
  line-height: 1.5rem;
  color: #fff;
}
.item_padding {
  padding: 0.1rem 0;
}
.goods_item {
  align-items: flex-start;
  position: relative;
  overflow: hidden;
  border-radius: 0.12rem;
  border: 0.04rem #ededed solid;
  .goods_img {
    width: 100%;
    height: 7rem;
    display: block;

    background: pink;
  }
  .content {
    padding: 0.32rem;
    .goods_name {
      margin-bottom: 0.32rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      color: #333;
    }
    .goods_menu {
      display: flex;
      align-items: center;
      .price {
        flex: 1;
      }
      .add_cart {
        background: #fff;
        padding: 0.15rem;
        border: 0.04rem #ddd solid;
        border-radius: 100%;
      }
    }
  }
}
</style>
<style lang='scss'>
.buy_btn_l {
  position: fixed;
  bottom: 2rem;
  right: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  .van-goods-action-icon {
    background: rgba($color: #000, $alpha: 0.2);
    border-radius: 100%;
    .van-goods-action-icon__icon {
      margin: 0 auto;
      font-size: 1rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/GoodsList.vue